<form [formGroup]="form" class="edit-form" (ngSubmit)="onSubmit()">
  <h1 mat-dialog-title>
    <span>{{ 'CHANGE_PASSWORD.HEADER' | translate }}</span>
  </h1>

  <mat-card-content fxLayout="column" fxLayoutAlign="center">
    <mat-form-field>
      <mat-placeholder>
        {{ 'CHANGE_PASSWORD.OLD_PASSWORD' | translate }}
      </mat-placeholder>
      <input
        matInput
        formControlName="oldPassword"
        [type]="oldPasswordHide ? 'password' : 'text'"
      />
      <mat-icon matSuffix (click)="oldPasswordHide = !oldPasswordHide">
        {{ oldPasswordHide ? 'visibility' : 'visibility_off' }}</mat-icon
      >
      <mat-error *ngIf="form.controls.oldPassword.errors?.required">
        {{ 'VALIDATIONS_MESSAGES.REQUIRED' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field>
      <mat-placeholder>
        {{ 'CHANGE_PASSWORD.NEW_PASSWORD' | translate }}
      </mat-placeholder>
      <input
        matInput
        formControlName="newPassword"
        required
        [type]="newPasswordHide ? 'password' : 'text'"
      />
      <mat-icon matSuffix (click)="newPasswordHide = !newPasswordHide">
        {{ newPasswordHide ? 'visibility' : 'visibility_off' }}</mat-icon
      >

      <mat-error *ngIf="form.controls.newPassword.errors?.required">
        {{ 'VALIDATIONS_MESSAGES.REQUIRED' | translate }}</mat-error
      >
      <mat-error *ngIf="form.controls.newPassword.hasError('minlength')">
        {{ 'VALIDATIONS_MESSAGES.MIN_LENGTH' | translate: { value: 6 } }}</mat-error
      >
      <mat-error *ngIf="form.controls.newPassword.hasError('invalidPassword')">
        {{ 'VALIDATIONS_MESSAGES.INVALID_PASSWORD' | translate }}</mat-error
      >
    </mat-form-field>
  </mat-card-content>

  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-raised-button type="submit" color="primary" [disabled]="!form.valid">
      <span>{{ 'GENERAL.SAVE_BUTTON' | translate }}</span>
    </button>
    <button mat-raised-button color="warn" type="button" (click)="close()">
      {{ 'GENERAL.CANCEL_BUTTON' | translate }}
    </button>
  </div>
</form>
<div *ngIf="saving" fxLayout="column" fxLayoutAlign="center center" class="user-spinner">
  <mat-spinner color="primary"></mat-spinner>
</div>
